import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const ExternalProductionDays = ({
    productionsIdSelecteds,
    productionsDaysIdSelecteds,
    setProductionsDaysIdSelecteds,
    setProductionsEmployeesSelecteds,
    setOperationsDaySelecteds,
    isOpen
}) => {
    const [idProductionsDays, setIdProductionsDays] = useState(null);
    const [externalProductionDay, setExternalProductionDay] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [recordsProductionDaysByUserId, setRecordsProductionDaysByUserId] = useState(null);
    const readOnlyAttributes = !(inserting || updating);

    const [attributesDetailProductionDaysPanel, setAttributesDetailProductionDaysPanel] = useState(null);

    const [loadingProductionDaysPanel, setLoadingProductionDaysPanel] = useState(null);

    const attributeList = [
        { name: "id", value: idProductionsDays, setter: setIdProductionsDays },
        { name: "externalProductionDay", value: externalProductionDay, setter: setExternalProductionDay },
        { name: "endDate", value: endDate, setter: setEndDate },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
    ];

    // O painel fica montado na Produção mesmo fechado: só busca quando aberto.
    // A grid depende da produção; salvar/excluir já recarregam, então clicar num dia não recarrega a grid.
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        reloadListProductionDays()
    }, [productionsIdSelecteds, isOpen]);

    useEffect(() => {
        setProductionsEmployeesSelecteds([])
        setOperationsDaySelecteds([])
    }, [productionsDaysIdSelecteds]);


    const fetchDataDetail = async (productionsDayIdSelected) => {
        const parameters = { id: productionsDayIdSelected }
        const productionDays = await ExecuteAxios.api('get', `/external-production-day/detail/`, { params: parameters })
        if (productionDays) {
            setAttributesDetailProductionDaysPanel(productionDays)
            ApplyAttributes.applyAttributes(productionDays, attributeList)
        }

        if (!productionsDayIdSelected || productionsDayIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        getDetailInformation();
    }, [productionsDaysIdSelecteds, isOpen]);

    function getDetailInformation() {
        if (productionsDaysIdSelecteds && productionsDaysIdSelecteds.length === 1) {
            fetchDataDetail(productionsDaysIdSelecteds[0]);
        } else {
            fetchDataDetail(0);
        }
    }

    async function getProductionDaysRecords(productionsDayIdSelected) {
        const parameters = { productionId: productionsDayIdSelected, externalProductionDay: new Date().toISOString().split("T")[0] }
        const productionDays = await ExecuteAxios.api('get', `/external-production-day/grid/`, { params: parameters });
        setRecordsProductionDaysByUserId(productionDays);
        RemoveIdsNotFound.remove(productionDays, setProductionsDaysIdSelecteds, productionsDayIdSelected)
    }

    const getProductionDaysPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setProductionsDaysIdSelecteds}
                    idsSelected={productionsDaysIdSelecteds}
                    data={recordsProductionDaysByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProductionDaysPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postProductionDays() {
        try {
            setLoadingProductionDaysPanel(true)
            const response = await ExecuteAxios.api('post', `/external-production-day/`, {
                productionId: productionsIdSelecteds[0],
                externalProductionDay: externalProductionDay,
                endDate: endDate
            });

            if (response) {
                await reloadListProductionDays()
            }

            return response
        } finally {
            setLoadingProductionDaysPanel(false)
        }
    }

    async function putProductionDays() {
        try {
            setLoadingProductionDaysPanel(false)
            const response = await ExecuteAxios.api('put', `/external-production-day/`, {
                id: productionsDaysIdSelecteds[0],
                productionId: productionsIdSelecteds[0],
                externalProductionDay: externalProductionDay,
                endDate: endDate
            });

            if (response) {
                await reloadListProductionDays()
            }

            return response;
        } finally {
            setLoadingProductionDaysPanel(false)
        }
    }

    async function reloadListProductionDays() {
        if (productionsIdSelecteds && productionsIdSelecteds.length === 1) {
            await getProductionDaysRecords(productionsIdSelecteds[0])
        } else {
            await getProductionDaysRecords(0)
        }
    }

    async function deleteProductionDays() {
        try {
            setLoadingProductionDaysPanel(true)
            const response = await ExecuteAxios.api('delete', `/external-production-day/`, {
                params: {
                    id: productionsDaysIdSelecteds[0]
                }
            });

            if (response) {
                await reloadListProductionDays()
            }

            return response
        } finally {
            setLoadingProductionDaysPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingProductionDaysPanel}>
            <Panel
                style={{ display: 'flex', height: '100%', flexDirection: 'column' }}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={productionsDaysIdSelecteds && productionsDaysIdSelecteds.length === 1}
                putFunction={putProductionDays}
                enableNewRecord={true}
                canNewRecord={!updating}
                postFunction={postProductionDays}
                enableDelete={true}
                deleteFunction={deleteProductionDays}
                canDelete={productionsDaysIdSelecteds && productionsDaysIdSelecteds.length == 1}
                canViewCRUD={true}
                recordsSelected={productionsDaysIdSelecteds}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailProductionDaysPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setProductionsDaysIdSelecteds}
            >
                {getProductionDaysPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );
};

export default ExternalProductionDays;


